import { defineComponent as _defineComponent } from 'vue'
import ComingSoonBox from '../UIComponents/ComingSoonBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilmVoting',
  setup(__props) {

const filmsImage = require('@/assets/my-theater/my-theater-films.png');

return { __sfc: true,filmsImage, ComingSoonBox }
}

})